var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavigationRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_158-right",
    "data-name": "158-right",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.33,
    height: 11.33,
    viewBox: "0 0 11.33 11.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_674",
    "data-name": "Path 674",
    d: "M97.479,140.291a.263.263,0,1,0-.371.371l1.99,1.99H93.81a.264.264,0,1,0,0,.527h5.284l-1.99,1.99a.262.262,0,0,0,0,.372.259.259,0,0,0,.187.076.27.27,0,0,0,.187-.076l2.438-2.437a.261.261,0,0,0,.076-.187.272.272,0,0,0-.076-.187Zm0,0",
    transform: "translate(-91.57 -137.25)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_675",
    "data-name": "Path 675",
    d: "M5.666-.075a5.666,5.666,0,1,0,4.006,1.66A5.665,5.665,0,0,0,5.666-.075Zm0,10.8A5.139,5.139,0,1,1,10.8,5.591,5.145,5.145,0,0,1,5.666,10.729Zm0,0",
    transform: "translate(0 0.075)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationRight);
export default __webpack_public_path__ + "static/media/NavigationRight.06754927924d10a3c1d734484e1389f0.svg";
export { ForwardRef as ReactComponent };